import EntityId from '../../../../foundation/domain/EntityId';
import Lesson from '../domain/aggregates/lesson/Lesson';
import Exercise from '../domain/aggregates/exercise/Exercise';
import Api from '../../../../foundation/api/Api';
import Registry from '../../../global/Registry';
import User from '../../users/domain/aggregates/user/User';
import Course from '../domain/aggregates/course/Course';

export default class ExerciseApi extends Api<Exercise> {

	private static instance?: ExerciseApi;

	public static getInstance () {
		return this.instance !== undefined ? this.instance : this.instance = new this(Registry.getInstance().exerciseRepository);
	}

	public async getAll () {
		return await this.getList('/api/exercises');
	}

	public async getAllByLessonId (lessonId: EntityId<Lesson>) {
		return await this.getList(['/api/exercises?lessonId=', lessonId]);
	}

	public async getById (exerciseId: EntityId<Exercise>) {
		return await this.getOne(['/api/exercises/', exerciseId]);
	}

	public async getAllToRepeatByUserId (userId: EntityId<User>) {
		return await this.getList(['/api/exercises?userId=', userId]);
	}

	public async getAllByCourseId (courseId: EntityId<Course>) {
		return await this.getList(['/api/exercises?courseId=', courseId]);
	}

	public async save (exercise: Exercise) {
		const data = {
			lessonId: exercise.getLessonId().getValue(),
			templateId: exercise.getTemplateId().getValue(),
			content: exercise.getContent(),
			contents: exercise.getContents()
		};

		return await this.postOne(exercise.hasId() ? ['/api/exercises/', exercise.getId()] : '/api/exercises', data);
	}

	public async delete (exerciseId: EntityId<Exercise>) {
		return await super.deleteOne(['/api/exercises/', exerciseId]);
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/lessons/api/ExerciseApi.ts